// extracted by mini-css-extract-plugin
export var actions = "CookiesPopup-module--actions--n00Nm";
export var cookiesPopup = "CookiesPopup-module--cookiesPopup--L1PGU";
export var decline = "CookiesPopup-module--decline--x5drT";